<template>
    <Navbar :title="'我的订阅'"></Navbar>
    
    <van-list class="subscribe-box" v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="getData">
        <div class="policy-file-item" v-for="record in list" :key="record" @click="goDetail">
                <list-item :record="record"></list-item>
                <div class="subscribe-btn-box">
                    <van-button class="subscribe-btn" type="primary" @click.stop="cancelSubscribe(record)">
                        <van-icon class="icon icon-like" name="like" color="#fff" />取消订阅
                        </van-button>
                </div>
            <div class="policy-file-item-footer">
                <div>最新<span>{{ record.total }}</span>条</div>
                <div>更新日期<span>{{ record.total }}</span></div>
            </div>
        </div>
    </van-list>

</template>
<script>

import { getPolicyByTags,getServiceProviderList } from "@/api/home"
import Navbar from '@/components/Navbar'
import ListItem from '@/components/ListItem.vue'
import { clickUrl } from '@/utils'
import {mapState} from 'vuex'

export default {

  data() {

    return {
      list: [],
      loading: false,
      finished: false,
    }
  },
  components: { Navbar, ListItem },
  computed: {},
 
  mounted() {
    
    this.getData()
  },
  watch: {},
  methods: {
    
    goDetail(item){
      clickUrl('/subscribe/list')
    },
    async getData(){
      let params = this.queryParams
      let res = await getPolicyByTags()
      this.list = res.data || []
    },
  }
}
</script>
<style lang="scss">
.subscribe-box{
    .policy-file-item{
        position: relative;
        .policy-file-item-title{
            margin-right: 100px;
        }
    }
    .subscribe-btn-box{
        position: absolute;
        top: 10px;
        right: 10px;
        height: 30px;
        .subscribe-btn{
            height: 100% !important;
            padding: 3px 5px;
            font-size: 12px;
            .icon-like{
                margin-right: 5px;
            }
        }
    }
}
</style>